import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { IncidentsApiAdapter } from '../adapters/IncidentsApiAdapter';
import type { UseIncidentsFilters } from './useIncidents';

/**
 * Totales por estado con el mismo criterio de filtros que el listado (sin filtro de pestaña).
 * Una sola petición: GET /incidents/count-by-status
 */
export const useIncidentsCountByStatus = (filtersBase: UseIncidentsFilters, enabled = true) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const apiAdapter = useMemo(() => new IncidentsApiAdapter(httpClient), [httpClient]);

  const filtersKey = useMemo(() => JSON.stringify(filtersBase), [filtersBase]);

  const {
    data: counts = {},
    isLoading,
    isPending,
  } = useQuery({
    queryKey: ['incidents-count-by-status', filtersKey],
    queryFn: () => apiAdapter.getIncidentsCountByStatus(filtersBase),
    enabled,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });

  const isLoadingCounts = isLoading || isPending;

  return { counts, isLoadingCounts };
};
